import { Wrapper } from 'styles/styleSystem/wrapper'
import { FintrosLogo } from 'components/FintrosLogo'
import { LoggedOutHeaderWrapper } from './styles'
import { Button, BUTTON_VARIANTS } from 'components/Button'
import Link from 'next/link'
import Header from 'components/Header'
import { useAuth } from 'contexts/AuthContext'
import { useEffect, useState } from 'react'
import { SkeletonLine } from 'components/Skeleton'

export const PageHeader: React.FC = () => {
  const { checkIsLoggedIn } = useAuth()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const check = async () => {
      const result = await checkIsLoggedIn()
      setIsLoggedIn(result)
      setLoading(false)
    }
    check()
  }, [])

  if (loading) {
    return <SkeletonLine width="100%" height="60px" margin="0" />
  }

  return isLoggedIn ? (
    <Header />
  ) : (
    <LoggedOutHeaderWrapper>
      <div>
        <Link href="/" legacyBehavior>
          <FintrosLogo />
        </Link>
      </div>
      <Wrapper display="flex" spacing={12} horizontal>
        <Link href="/login?=beta" legacyBehavior>
          <Button variant={BUTTON_VARIANTS.primary} size="lg">
            Login
          </Button>
        </Link>
        <Link href="/join" legacyBehavior>
          <Button variant={BUTTON_VARIANTS.secondary} size="lg">
            Join
          </Button>
        </Link>
      </Wrapper>
    </LoggedOutHeaderWrapper>
  )
}
